import Hamburgermenu from '../images/icon-hamburger.svg' ;

const MenuButton = () => {
    return (
        <>
            <button>
                <img src={Hamburgermenu} alt="" />
            </button>
        </>
    )
}

export default MenuButton
